export const pluralize = (num: number, singular: string, plural: string) => `${num} ${num === 1 ? singular : plural}`;

export const upperFirst = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const upperFirstEveryWord = (words: string) => {
  const parts = words.split(' ');
  return parts.map(upperFirst).join(' ');
};
